module.exports = __webpack_public_path__ + "assets/images/10HL.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/10HL.png
// module id = 1282
// module chunks = 1